<div class="content-wrapper">
    <div class="content-body">
        <section id="insights">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'INSIGHT_ICON'">Insight Content - {{viewContentData?.heading}}</h4>
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'INSIGHT_CONTENT'">Insight Content - {{viewContentData?.heading}}</h4>
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'POPULAR_LINKS'">Popular Links</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row p-1" *ngIf="modalType === 'INSIGHT_CONTENT'">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" [innerHTML]="sanitizedContent"></div>
                        </div>
                        <div class="row" *ngIf="imageChangedIconEvent && modalType === 'INSIGHT_ICON'">
                            <div class="text-center col-md-12">
                                <image-cropper
                                        [imageChangedEvent]="imageChangedIconEvent"
                                        [maintainAspectRatio]="true"
                                        [aspectRatio]="3 / 4"
                                        [resizeToWidth]="400"
                                        format="png, jpeg, jpg"
                                        (imageCropped)="imageIconCropped($event)"
                                        (imageLoaded)="imageLoaded()"
                                        (cropperReady)="cropperReady()"
                                        (loadImageFailed)="loadImageFailed()">
                                </image-cropper>
                            </div>
                            <div class="text-center display-hidden">
                                <img [src]="croppedIconImage" width="150px" height="150px"/>
                            </div>
                        </div>
                        <div class="row" *ngIf="!imageChangedIconEvent && modalType === 'INSIGHT_ICON'">
                            <div class="col-sm-3"></div>
                            <div class="col-sm-6">
                                <div class="profile-with-cover text-center">
                                    <div class="card-img-top img-fluid bg-cover height-300 profile-background-image image-upload-area cursor-pointer mt-1 mb-1"
                                         *ngIf="!imageChangedIconEvent" (click)="fileIconUpload.click()"></div>
                                    <input class="form-control-file display-hidden" type="file"
                                           (change)="fileChangeIconEvent($event)" #fileIconUpload>
                                </div>
                            </div>
                            <div class="col-sm-3" *ngIf="!imageChangedIconEvent"></div>
                        </div>
                        <div *ngIf="modalType === 'POPULAR_LINKS'">
                            <form [formGroup]="popularLinkForm" (ngSubmit)="addPopularLink()" class="row align-items-end">
                                <div class="col-12 mb-2">
                                    <label>Type</label>
                                    <select class="form-control" formControlName="type" (change)="onPopularLinkTypeChange()">
                                        <option *ngFor="let type of popularLinkTypes" [value]="type.value">{{type.label}}</option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-5 mb-2 mb-md-0">
                                    <label>Title</label>
                                    <input class="form-control" type="text" formControlName="title" placeholder="Title">
                                </div>
                                <div class="col-12 col-md-5 mb-2 mb-md-0">
                                    <label>URL</label>
                                    <input class="form-control" type="text" formControlName="url" placeholder="Url">
                                </div>
                                <div class="col-12 col-md-2 mb-2 mb-md-0">
                                    <button class="btn btn-primary btn-block" type="submit" [disabled]="popularLinkSubmitting">
                                        <i class="fas fa-spinner fa-pulse" *ngIf="popularLinkSubmitting"></i>
                                        <span *ngIf="!popularLinkSubmitting">Add</span>
                                    </button>
                                </div>
                            </form>
                            <div class="table-responsive mt-2">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Url</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let link of popularLinks">
                                        <td>{{link.title}}</td>
                                        <td class="text-break">{{link.url}}</td>
                                        <td class="text-center">
                                            <i class="fas fa-trash text-danger cursor-pointer" (click)="deletePopularLink(link.id)"></i>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!popularLinks || popularLinks.length === 0">
                                        <td colspan="3" class="text-center">No popular links added yet</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-center" *ngIf="popularLinkPagination.total > popularLinkPagination.perpage">
                                <ngb-pagination (pageChange)="onPopularLinkPageChange($event)"
                                                [(page)]="popularLinkPagination.page"
                                                [boundaryLinks]="true"
                                                [collectionSize]="popularLinkPagination.total"
                                                [maxSize]="5"
                                                [pageSize]="popularLinkPagination.perpage">
                                </ngb-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary btn-raised" type="button"
                                *ngIf="imageChangedIconEvent && modalType === 'INSIGHT_ICON'"
                                (click)="saveOnInsightIcon()">
                            <i class="fa fa-save mr-1"></i> Save
                        </button>
                        <button class="btn btn-danger color-white pull-right" (click)="modalService.dismissAll('')">Close</button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Insights</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2 cursor-pointer"
                            (click)="add()">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Add Insight
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2 cursor-pointer"
                            (click)="openPopularLinksModal(content)">
                        <i aria-hidden="true" class="fa fa-link mr-8px"></i>&nbsp;Popular Links
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="category"
                                           placeholder="Category">
                                </fieldset>
                            </div>
                            <div class="col-md-3  col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="heading"
                                           placeholder="heading">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="url"
                                           placeholder="Url">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-sm-4 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row d-none d-md-block overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list border-0">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Category</h6>
                                            </th>
                                            <th class="text-center text-nowrap"><h6 class="mt-1 mb-1 font-weight-bold">Sub Category</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Heading</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Url</h6>
                                            </th>
                                            <th class="text-center text-nowrap"><h6 class="mt-1 mb-1 font-weight-bold">Meta Title</h6>
                                            </th>
                                            <th class="text-center text-nowrap px-5"><h6 class="mt-1 mb-1 font-weight-bold">Meta Description</h6>
                                            </th>
                                            <th class="text-center text-nowrap px-5"><h6 class="mt-1 mb-1 font-weight-bold">Meta Keywords</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Banner</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Cover</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Content</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="insights && insights.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let insight of insights; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                    .</h6>
                                            </td>

                                            <td class="text-center"><h6 class="mt-1">{{insight['insights_category']?.name}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{insight['insights_subcategory']?.name}}</h6></td>
                                           <!-- <td class="text-center"><h6 class="mt-1">{{insight?.category}}</h6></td>-->
                                            <td class="text-center"><h6 class="mt-1">{{insight?.heading}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{insight?.url}}</h6></td>
                                            <td class="text-center "><h6 class="mt-1">{{insight?.meta_title}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{insight?.meta_description}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{insight?.meta_keyword}}</h6></td>
                                            <td class="text-center">
                                                <div class="btn-group" role="group"
                                                     *ngIf="insight && insight['banner']">
                                                    <button type="button" class="btn btn-primary" title="Upload Banner"
                                                            (click)="bannerUpload.click()">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-primary" title="View Banner"
                                                            (click)="openInsightBanner(insight)">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                </div>
                                                <button class="btn btn-primary color-white" title="Upload Cover"
                                                        (click)="bannerUpload.click()"
                                                        *ngIf="insight && !insight['banner']">
                                                    <i class="fas fa-cloud-upload-alt"></i>
                                                </button>
                                                <input class="form-control-file display-hidden" type="file"
                                                       (change)="onFileChange($event, 'INSIGHT_BANNER', insight)"
                                                       #bannerUpload>
                                            </td>
                                            <td class="text-center">
                                                <!--<div class="btn-group" role="group"
                                                     *ngIf="insight && insight['cover']">
                                                    <button type="button" class="btn btn-primary" title="Upload Cover"
                                                            (click)="coverUpload.click()">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-primary" title="View Cover"
                                                            (click)="openInsightCover(insight)">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                </div>
                                                <button class="btn btn-primary color-white" title="Upload Cover"
                                                        (click)="coverUpload.click()"
                                                        *ngIf="insight && !insight['cover']">
                                                    <i class="fas fa-cloud-upload-alt"></i>
                                                </button>
                                                <input class="form-control-file display-hidden" type="file"
                                                       (change)="onFileChange($event, 'INSIGHT_ICON', insight)"
                                                       #coverUpload>-->
                                                <button type="button" class="btn btn-primary" title="Upload Icon"
                                                        (click)="openInsightIconModal(content, insight.id)"
                                                        *ngIf="insight && !insight['icon']">
                                                    <i class="fas fa-cloud-upload-alt"></i>
                                                </button>
                                                <div class="btn-group" role="group"
                                                     *ngIf="insight && insight['icon']">
                                                    <button type="button" class="btn btn-primary"
                                                            title="Upload Icon"
                                                            (click)="openInsightIconModal(content, insight.id)"
                                                            *ngIf="insight && insight['icon']">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-primary" title="View Cover"
                                                            (click)="openInsightIcon(insight)">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <h6 class="mt-1 badge badge-pill badge-primary cursor-pointer"
                                                    (click)="viewContent(content, insight)">View
                                                    Content</h6>
                                            </td>
                                            <td class="text-center" style="width: 200px">
                                                <div class="d-flex">
                                                    <i aria-hidden="true"
                                                       class="fa fa-plus-circle f_20 text-success cursor-pointer font-weight-light mt-1 mr-1 ml-1"
                                                       title="Add in top list"
                                                       (click)="addInTopTen('ACTIVE', insight)"
                                                       *ngIf="insight && insight['active_ten'] && insight['active_ten'] === 'INACTIVE'">
                                                    </i>

                                                    <div class=" border border-danger rounded-circle text-center d-flex align-items-center mr-1  justify-content-center" style="padding:10px; height: 10px ; width: 10px; margin-top: 13px" *ngIf="insight && insight['active_ten'] && insight['active_ten'] === 'ACTIVE'">
                                                            <i aria-hidden="true"
                                                               class="fa fa-minus  text-danger cursor-pointer font-weight-light "
                                                               title="Remove from top list"
                                                               (click)="addInTopTen('INACTIVE', insight)"
                                                               >
                                                    </i>
                                                    </div>

                                                    <i aria-hidden="true"
                                                       class="fa fa-star f_20 text-secondary cursor-pointer font-weight-light mt-1 mr-1 ml-1"
                                                       title="Mark as Main"
                                                       (click)="updateMain('ACTIVE', insight)"
                                                       *ngIf="!insight || !insight['main'] || insight['main'] === 'INACTIVE'">
                                                    </i>
                                                    <i aria-hidden="true"
                                                       class="fa fa-star f_20 text-warning cursor-pointer font-weight-light mt-1 mr-1 ml-1"
                                                       title="Remove as Main"
                                                       (click)="updateMain('INACTIVE', insight)"
                                                       *ngIf="insight && insight['main'] === 'ACTIVE'">
                                                    </i>

                                                    <i aria-hidden="true"
                                                       class="fas fa-edit f_20 text-info cursor-pointer font-weight-light mt-1"
                                                       title="Edit" (click)="edit(insight)"></i>
                                                    <i class="fas fa-check-circle f_20 text-success cursor-pointer font-weight-light mt-1 mr-1 ml-1"
                                                       title="Active"
                                                       (click)="updateStatus('ACTIVE', insight)"
                                                       *ngIf="insight && insight['status'] && insight['status'] === 'IN_ACTIVE'"></i>
                                                    <i class="fas fa-times-circle f_20 text-danger cursor-pointer font-weight-light mt-1 mr-1 ml-1"
                                                       title="In Active"
                                                       (click)="updateStatus('IN_ACTIVE', insight)"
                                                       *ngIf="insight && insight['status'] && insight['status'] === 'ACTIVE'"></i>
                                                    <i aria-hidden="true"
                                                       class="fab fa-artstation f_20 mt-1 text-primary cursor-pointer font-weight-light"
                                                       title="Perform Actions" (click)="insightsInfoPage(insight)"></i>
                                                    <i class="fas fa-trash f_20 mt-1 ml-2 text-danger" (click)="delete(insight.id)"></i>
                                                </div>

                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="7" class="text-center"><h6>No data to show</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 d-block d-md-none" *ngIf="insights && insights.length > 0; else noDataToShowMobile">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card" *ngFor="let insight of insights; let i = index">
                        <div class="card-header bottom-shadow-light pb-18px">
                            <div class="row width-100-per">
                                <div class="col-6">
                                    <h4
                                            class="card-title text-uppercase card-ellipsis">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                        . {{insight?.name}}</h4>
                                </div>
                                <div class="col-6">
                                    <!-- <i aria-hidden="true"
                                        class="fas fa-lock f_20 ml-1 text-danger cursor-pointer pull-right"
                                        title="In Active Executive" *ngIf="insight?.status === 'ACTIVE'"
                                        (click)="updateStatus('INACTIVE', insight)"></i>
                                     <i aria-hidden="true"
                                        class="fas fa-lock-open ml-1 f_20 text-success cursor-pointer pull-right"
                                        title="Active Executive" *ngIf="insight?.status === 'INACTIVE'"
                                        (click)="updateStatus('ACTIVE', insight)"></i>-->
                                    <i aria-hidden="true"
                                       class="fas fa-edit f_20 text-info cursor-pointer font-weight-light pull-right"
                                       title="Edit" (click)="edit(insight)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row p-2">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Category - {{insight?.category}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Heading - {{insight?.heading}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    url - {{insight?.url}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Content - {{insight?.content}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
    <core-sidebar
            class="modal modal-slide-in sidebar-todo-modal fade"
            name="add-insight"
            overlayClass="modal-backdrop">
        <app-add-insights [data]="data" (valueSubmitted)="getData($event)"></app-add-insights>
    </core-sidebar>

</div>

